'use strict'

const LoungesOptions = {
  buttonText: 'Find out more',
  buttonLink: '/airport-lounges.html',
  idName: 'lounge'
}

module.exports = LoungesOptions



// WEBPACK FOOTER //
// ./_layouts/_templates/_includes/homepageProductsNav/lounges.jsx